import DownloadIcon from "@mui/icons-material/SaveAltRounded";
import { IconButton, Stack } from "@mui/material";
import type { FundStructureDocument } from "../../../../api/types/fundStructureTypes";
import useClientContext from "../../../../context/useClientContext";
import AnalyticsIcon from "@entrilia/shared/icons/AnalyticsIcon";

interface Props {
  row: FundStructureDocument;
  attachmentId: string | undefined;
  onNavigateToDocumentActivity?: (postMessageRequestId: string, attachmentId: string) => void;
  onDownloadClick: (row: FundStructureDocument) => void;
}

const FundStructureDocumentsGridActions = ({
  row,
  attachmentId,
  onNavigateToDocumentActivity,
  onDownloadClick,
}: Props) => {
  const { hasPermissions, investorPortalApp } = useClientContext();

  const hasAccessToDocumentActivity = hasPermissions(["ViewInvestorPortalDocumentViewsAnalytics"]);

  return (
    <Stack direction="row" spacing={0.5} sx={{ width: "100%", justifyContent: "flex-end" }}>
      {investorPortalApp && hasAccessToDocumentActivity && onNavigateToDocumentActivity && attachmentId && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onNavigateToDocumentActivity(row.postMessageRequestId, attachmentId);
          }}
        >
          <AnalyticsIcon />
        </IconButton>
      )}
      {row.attachmentIds.length > 0 && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onDownloadClick(row);
          }}
        >
          <DownloadIcon />
        </IconButton>
      )}
    </Stack>
  );
};

export default FundStructureDocumentsGridActions;
